<template>
<div class="Login">
  <div class="wrapper-login">
    <div class="frame">
      <div class="logo-home"> <img class="responsive-img top-logo" src="https://cdn0.archipelagointernational.com/BrandManual/assets/images/Logo-Archipelago-International-300.png" alt="Archipelago International" /> </div>
      <div class="container all-brands">
        <br /><br />
        <!--v-lazy-image class="responsive-img hide-on-small-only no-border" src="https://cdn0.archipelagointernational.com/BrandManual/assets/images/log-in-page-desktop-logo-2.png" alt="All Brands" />
        <v-lazy-image class="responsive-img hide-on-med-and-up no-border" src="https://cdn0.archipelagointernational.com/BrandManual/assets/images/log-in-page-logo-2.png" alt="All Brands" /-->
      </div>
      <div class="container">
        <div class="col s12 center-align">
          <h4>ARCH STAFF INFORMATION CHANNEL</h4>
          <br />
            <img class="responsive-img img-login" v-if="!isLoading" @click="handleClickGetAuth" alt="sign in with google" src="https://cdn0.archipelagointernational.com/itportal/assets/images/btn_google_signin_light_pressed_web.png" />
          <br />
          <br />
          <div class="separator">
            <p class="change_link">Request an access ?<br /> Please send an email to CorporateHR@ArchipelagoInternational.com</p>
            <div class="clearfix"></div> <br />
          </div>
        </div>
      </div>
      <div class="text-copy-home">
        <p>&copy; {{new Date().getFullYear()}} Archipelago International</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import router from '../router'
export default {
  name: 'Login',
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    handleClickGetAuth() {
      this.isLoading = true;
      this.$gAuth.getAuthCode()
        .then(authCode => {
          // On success
          //console.log(authCode);
          let params = new URLSearchParams();
          params.append('code', authCode);
          params.append('redirect_uri', 'postmessage');
          axios({
            method: 'post',
            url: 'https://www.archipelagointernational.com/api/asic/login',
            data: params
          }).then(function(response) {
            //console.log(response)
            //console.log(response.data)
            if (response.data.message == "Success") {
              $cookies.set("arch-asic", response.data.token, 60 * 60 * 8);
              router.push({
                name: 'Dashboard'
              })
            } else {
              alert(response.data.message)
              this.isLoading = true;
            }
          });
        })
        .then(response => {
          // And then
        })
        .catch(error => {
          // On fail do something
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue